import { ReactNode } from 'react'

type Props = {
  mobile?: ReactNode
  desktop?: ReactNode
}

const ResponsiveWrapper = ({ mobile, desktop }: Props) => (
  <>
    {!!mobile && <div className="u-phones-only">{mobile}</div>}
    {!!desktop && <div className="u-tablets-up-only">{desktop}</div>}
  </>
)

export default ResponsiveWrapper
